/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-badge-indicator {
  align-items: center;
  background-color: var(--qds-theme-feedback-message-neutral);
  border-radius: var(--qds-feedback-rounded-border-radius);
  display: flex;
  height: var(--qds-badge-indicator-standard-height);
  justify-content: center;
  width: var(--qds-badge-indicator-standard-height);
}

.qds-stroke-ring {
  border: var(--qds-feedback-badge-border-width) solid
    var(--qds-theme-feedback-message-neutral-contrast);
}

.qds-sr-only {
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
}

[data-status='error'] {
  background-color: var(--qds-theme-feedback-message-critical);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='info'] {
  background-color: var(--qds-theme-feedback-message-informational);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='neutral'] {
  background-color: var(--qds-theme-feedback-availability-unavailable);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='success'] {
  background-color: var(--qds-theme-signature-color-default);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-status='warning'] {
  background-color: var(--qds-theme-feedback-message-important);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-size='small'] {
  height: var(--qds-feedback-badge-indicator-small-size);
  width: var(--qds-feedback-badge-indicator-small-size);
}

[data-size='standard'] {
  height: var(--qds-feedback-badge-indicator-standard-size);
  width: var(--qds-feedback-badge-indicator-standard-size);
}

[data-size='large'] {
  height: var(--qds-feedback-badge-indicator-large-size);
  width: var(--qds-feedback-badge-indicator-large-size);
}

[data-size='hero'] {
  height: var(--qds-feedback-badge-indicator-hero-size);
  width: var(--qds-feedback-badge-indicator-hero-size);
}
